import { Grid } from "@mui/material";
import { useState } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../../../../components/CustomButton";
import TextInput from "../../../../components/TextInput";
import { userSetupSlice } from "../../../../store/reducer/user_setup";
import { authSlice } from "../../../../store/reducer/auth";
import { RootState } from "../../../../store";
import { userSlice } from "../../../../store/reducer/user";

const EnterEmail = () => {
    const dispatch = useDispatch();
    const emailError = useSelector((state: RootState) => state.auth.formErrors.email);
    let [email, setEmail] = useState('');

    return (
        <ValidatorForm
            instantValidate={false}
            onSubmit={async () => {
                dispatch(authSlice.actions.resetFormErrors());
                dispatch(userSlice.actions.updateUserData({
                    email: email
                }));
                dispatch(authSlice.actions.resetError());
                dispatch(authSlice.actions.precogAutoValidateRegistrationField({
                    fields: { 'email' : email }, 
                    next: '/register/ssn'
                }));
            }}>
            <br />
            <Grid className='form-row' size={12}>
            <TextInput
                aria-required
                label="Email"
                placeholder="Email"
                value={email}
                name="email"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    setEmail(e.target.value);
                }}
                autoComplete="off"
                error={!!emailError}
                helperText={!!emailError ? emailError : ''}
                validators={['required', 'isEmail']}
                errorMessages={['This field is required', 'Email is not valid']}
            />
            </Grid>
            <div className='btn-container single'>
                <CustomButton
                    variant="contained"
                    disableElevation={true}
                    label={"next"}
                    type="submit"
                    buttonSize="btn-lg"
                />
            </div>
        </ValidatorForm>
    );
};

export default EnterEmail;
